import * as React from 'react'
import hexLight from 'assets/hex-light.svg'
import hexDark from 'assets/hex-dark.svg'
import * as css from './HexPatternSection.module.css'
import clsx from 'clsx'

const HexPatternSection = ({ className, children, style, dark }) => (
  <div className={clsx(className, 'relative py-16')} style={style}>
    <figure className={css.hex}>
      <img
        src={dark ? hexDark : hexLight}
        alt=""
        width={767} height={402}
        loading="lazy" draggable="false"
      />
    </figure>

    <div className="relative px-4">
      {children}
    </div>
  </div>
)

export default HexPatternSection
